import { render, staticRenderFns } from "./SignUpMembership.vue?vue&type=template&id=45f826a4&"
import script from "./SignUpMembership.vue?vue&type=script&lang=js&"
export * from "./SignUpMembership.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports